import React, { useEffect, useState } from 'react';
import { archiveApi, cameraApi } from '../../services/api';
import './Archive.css';

export default function Archive() {
  const [recs, setRecs] = useState<any[]>([]);
  const [cameras, setCameras] = useState<any[]>([]);
  const [filter, setFilter] = useState({ camera: '', has_person: '', date: '' });
  const [loading, setLoading] = useState(true);
  const [playing, setPlaying] = useState<any | null>(null);

  useEffect(() => { cameraApi.list().then(({ data }) => setCameras(data.results || data)); }, []);
  useEffect(() => {
    setLoading(true);
    const params: any = {};
    if (filter.camera) params.camera = filter.camera;
    if (filter.has_person) params.has_person = true;
    if (filter.date) params.date = filter.date;
    archiveApi.list(params).then(({ data }) => setRecs(data.results || data)).finally(() => setLoading(false));
  }, [filter]);

  const fmt = (dt: string) => {
    const d = new Date(dt);
    return d.toLocaleDateString('az-AZ') + ' ' + d.toLocaleTimeString('az-AZ', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="ar-page">
      {playing && (
        <div className="ar-modal" onClick={() => setPlaying(null)}>
          <div className="ar-modal-inner" onClick={e => e.stopPropagation()}>
            <button className="ar-close" onClick={() => setPlaying(null)}>✕</button>
            <div className="ar-modal-title">{playing.filename}</div>
            <video
              src={playing.download_url}
              controls
              autoPlay
              className="ar-video"
            />
          </div>
        </div>
      )}

      <div className="ar-toolbar">
        <select value={filter.camera} onChange={e => setFilter(f => ({ ...f, camera: e.target.value }))}>
          <option value="">Bütün kameralar</option>
          {cameras.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <input type="date" value={filter.date} onChange={e => setFilter(f => ({ ...f, date: e.target.value }))} />
        <label className="ar-check">
          <input type="checkbox" checked={!!filter.has_person} onChange={e => setFilter(f => ({ ...f, has_person: e.target.checked ? '1' : '' }))} />
          Yalnız insan
        </label>
        <span className="ar-count">{recs.length} qeyd</span>
      </div>

      {loading ? <div className="ar-loading">Yüklənir...</div> : (
        <div className="ar-list">
          {recs.map(r => (
            <div key={r.id} className="ar-item">
              <div className="ar-thumb">🎬</div>
              <div className="ar-info">
                <div className="ar-fname">{r.filename}</div>
                <div className="ar-meta">
                  {r.camera_name} · {fmt(r.recorded_at)}
                  {r.has_person && <span className="ar-tag person">İnsan</span>}
                  {r.has_motion && <span className="ar-tag motion">Hərəkət</span>}
                </div>
              </div>
              <div className="ar-size">{r.file_size_mb} MB</div>
              <div className="ar-actions">
                <button className="ar-btn play" onClick={() => setPlaying(r)}>▶ Oynat</button>
                <a className="ar-btn download" href={r.download_url} download={r.filename}>↓ Yüklə</a>
              </div>
            </div>
          ))}
          {!recs.length && <div className="ar-empty">Qeyd tapılmadı</div>}
        </div>
      )}
    </div>
  );
}
